import { helper } from '@ember/component/helper';
import humanize from '../utils/humanize';

export function abbreviate([str]) {
  return humanize(str);
}

export default helper(abbreviate);
